export default __webpack_public_path__ + "static/media/person_2@2x.4f96c513.png";